import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Zap } from "lucide-react";

export default function Skills() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/skills").then((r) => setD(r.data)); }, []);
  if (!d) return <div className="p-8 text-tc-muted font-mono text-sm">Loading skills…</div>;

  return (
    <div className="p-4 sm:p-6 lg:p-8 max-w-4xl mx-auto space-y-6">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight">Skill Mastery</h1>
        <p className="text-tc-sub mt-1">{d.note}</p>
      </div>

      <div className="tc-card p-5 border-tc-mastery/25 bg-gradient-to-br from-tc-mastery/10 to-transparent">
        <div className="flex items-center gap-2 text-xs font-mono uppercase tracking-widest text-tc-mastery"><Zap className="w-3.5 h-3.5" /> Recommended Focus</div>
        <div className="font-heading text-xl font-bold mt-1">{d.focus.title}</div>
        <p className="text-tc-sub text-sm mt-1">{d.focus.description}</p>
      </div>

      <div className="tc-card p-5 space-y-3.5" data-testid="skills-list">
        {d.skills.map((s) => (
          <div key={s.key}>
            <div className="flex justify-between text-sm mb-1"><span className="text-tc-sub">{s.label}</span><span className="font-mono text-tc-mastery">{(s.mastery * 100).toFixed(0)}%</span></div>
            <div className="h-2 rounded-full bg-white/10 overflow-hidden">
              <div className="h-full bg-gradient-to-r from-tc-mastery to-tc-mastery/60 rounded-full transition-all" style={{ width: `${s.mastery * 100}%` }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
